// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ConcurrentSessionsBehaviorSchema = z.enum(['ALLOWED','ONE_PER_ACCOUNT','UNKNOWN'] as const);

export type ConcurrentSessionsBehaviorType = `${z.infer<typeof ConcurrentSessionsBehaviorSchema>}`

export default ConcurrentSessionsBehaviorSchema;
